<div class="page-content">
  <!-- Page Header -->
  <div class="content-head">
    <div>
      <div class="eyebrow">INBOX</div>
      <h2>Notifications</h2>
      <p>Stay on top of the actions that keep your placement cycle moving.</p>
    </div>
    <button type="button" class="outline-button" (click)="onMarkAllRead()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
      Mark all as read
    </button>
  </div>

  <!-- Notifications Panel -->
  <section class="panel">
    <div class="panel-heading">
      <h2>Your notifications</h2>
    </div>

    <div class="notification-list">
      <div 
        *ngFor="let n of notifications" 
        class="notification-row" 
        [class.unread]="n.unread"
        (click)="onNotificationClick(n)">
        
        <div class="attention-icon purple">
          <svg *ngIf="n.iconType === 'building'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect width="16" height="20" x="4" y="2" rx="2" ry="2"/><path d="M9 22v-4h6v4"/></svg>
          <svg *ngIf="n.iconType === 'clipboard'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
          <svg *ngIf="n.iconType === 'calendar'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="3" x2="21" y1="10" y2="10"/></svg>
          <svg *ngIf="n.iconType === 'report' || n.iconType === 'bell'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
        </div>

        <div class="notification-body">
          <strong>{{ n.title }}</strong>
          <p>{{ n.description }}</p>
          <span>{{ n.time }}</span>
        </div>

        <i *ngIf="n.unread" class="unread-dot"></i>
      </div>
    </div>
  </section>
</div>
